function buildPopUpWindowHtml(propertyId, propertyLink, propertyImageUrl, propertyPrice, propertyBedroom, propertyAddress, propertyReference) {
    var content = '';
    content += '<div';

    if (propertyId !== null)
        content += ' id=\"property-' + propertyId + '\"';

    content += ' class=\"info-window-content\">' + '<i class=\"close-info-window fa fa-times-circle-o\"  onclick=\"closeWindow()\"></i>' +
        '<a href=\"' + propertyLink + '\"><img src=\"' + propertyImageUrl + '\" /><address>' + propertyAddress + '</address></a>' + '</div>';

    return content;
}

function addClassesToPopUpWindow() {
    $('.gm-style-iw').next('div').hide(); // Hide the close button
    $('.gm-style-iw').parent().addClass('gm-style-iw-parent');
    $($($('.gm-style-iw-parent').children()[0]).children()[1]).addClass("gm-style-iw-outer-boarder");
    $($($('.gm-style-iw-parent').children()[0]).children()[3]).addClass("gm-style-iw-outer-boarder");
    $($($($($('.gm-style-iw-parent').children()[0]).children()[2]).children()[0]).children()[0]).addClass("gm-style-iw-pointer-left");
    $($($($($('.gm-style-iw-parent').children()[0]).children()[2]).children()[1]).children()[0]).addClass("gm-style-iw-pointer-right");
}
